import {SET_RESOLUTION} from 'constants/action-types.js';
import {SET_WAVEFORM_SHOWING} from 'constants/action-types.js';
import {SET_IS_TRANSCRIBING} from 'constants/action-types.js';
import {SET_UPLOADING_FILE} from 'constants/action-types.js';
import {SET_SEQUENCER_ENGINE} from 'constants/action-types.js';
import {SET_SELECTOR_MODE} from 'constants/action-types.js';
import {SET_VIEW_MODE} from 'constants/action-types.js';
import {SET_DETAILS_VIEW} from 'constants/action-types.js';
import {SET_DECENTRALIZED} from 'constants/action-types.js';

import {SET_CURRENT_PATTERN} from 'constants/action-types.js';
import {SET_NUMBER_PATTERNS} from 'constants/action-types.js';
import {SET_CURRENT_STEP} from 'constants/action-types.js';
import {SET_CURRENT_AND_GLOBAL_STEPS} from 'constants/action-types.js';
import {SET_CURRENT_GLOBAL_STEP} from 'constants/action-types.js';
import {SET_IS_PLAYING} from 'constants/action-types.js';

import {SET_SAMPLE_PACK} from 'constants/action-types.js';
import {DRAG_SAMPLE} from 'constants/action-types.js';
import {DRAG_EFFECT} from 'constants/action-types.js';
import {DRAG_PATTERN} from 'constants/action-types.js';
import {TRACK_RECORDING} from 'constants/action-types.js';
import {TRACK_PREPARING_TO_RECORD} from 'constants/action-types.js';
import {SET_QUANTIZED} from 'constants/action-types.js';
import {SET_IS_RECORDING} from 'constants/action-types.js';
import {SET_IS_RECORDING_EXPANDED} from 'constants/action-types.js';
import {SET_SEQUENCE_NAME} from 'constants/action-types.js';
import {SET_WALLPAPER} from 'constants/action-types.js';
import {SET_ANIMATE_WALLPAPER} from 'constants/action-types.js';
import {SET_TRACK_FOCUSED} from 'constants/action-types.js';
import {SET_LOADING_SEQUENCE} from 'constants/action-types.js';
import {SET_MASTER_VOLUME} from 'constants/action-types.js';
import {SET_SHOW_LOGIN} from 'constants/action-types.js';
import {SET_USER_TOKEN} from 'constants/action-types.js';
import {SET_SIGNING_UP} from 'constants/action-types.js';
import {SET_COMPACT_MODE} from 'constants/action-types.js';
import {SET_SHOW_LFOS} from 'constants/action-types.js';
import {SET_SHOW_ENVELOPES} from 'constants/action-types.js';
import {SET_PROJECT_AUTOMATION_MODE} from 'constants/action-types.js';
import {NEW_SEQUENCE} from 'constants/action-types.js';
import {SET_SHOW_SEQUENCE_MODAL} from 'constants/action-types.js';
import {SET_SHOW_MODS_MODAL} from 'constants/action-types.js';
import {SET_SEQUENCE_ROLLING} from 'constants/action-types.js';
import {SET_TRACK_ROLLING} from 'constants/action-types.js';
import {PLAY} from 'constants/automation-modes.js';
import {SET_SHOW_SEQUENCES} from 'constants/action-types.js';
import {SET_SHOW_PRESETS} from 'constants/action-types.js';
import {SET_SHOW_INSTRUMENTS} from 'constants/action-types.js';
import {SET_Z_INDEX_HACK} from 'constants/action-types.js';
import {SET_RESAMPLE_MASTER} from 'constants/action-types.js';
import {SET_AUDIO_INPUT_SOURCE} from 'constants/action-types.js';
import {SET_LATENCY} from 'constants/action-types.js';
import {SET_SEQUENCE_PATTERN_LOCKED} from 'constants/action-types.js';
import {SET_SEQUENCE_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_SHOW_SETTINGS} from 'constants/action-types.js';
import {SET_CLOCK_TYPE} from 'constants/action-types.js';
import {SET_SHOW_CONVOLVER_MODAL} from 'constants/action-types.js';
import {SET_SHOW_PASSWORD_MODAL} from 'constants/action-types.js';
import {SET_PASSWORD_MODAL_CALLBACK} from 'constants/action-types.js';
import {SET_CONTEXTUAL_HELP} from 'constants/action-types.js';
import {SET_SELECTED_LFO} from 'constants/action-types.js';
import {SET_SELECTED_ENVELOPE} from 'constants/action-types.js';
import {SET_SHOW_GROUPS} from 'constants/action-types.js';
import {SET_SUB_SEQUENCES} from 'constants/action-types.js';
import {SET_CURRENT_SUB_SEQUENCE} from 'constants/action-types.js';
import {SET_SIDEBAR_VIEW_MODE} from 'constants/action-types.js';
import {SET_SHOW_PIANO_ROLL} from 'constants/action-types.js';
import {SET_SEQUENCE_LOADING_PROGRESS} from 'constants/action-types.js';
import {SET_DISPLAY_RESOLUTION} from 'constants/action-types.js';
import {SET_LOADING_TEXT} from 'constants/action-types.js';
import {SET_SCENES} from 'constants/action-types.js';
import {SET_CURRENT_SCENE} from 'constants/action-types.js';
import {NONE} from 'constants/clock-types.js';
import {SOUNDS} from 'constants/sidebar-view-modes.js';
import Resolution from 'engine/Resolution.js';
import {
    SEQUENCER_VIEW, MIX_VIEW, ARRANGEMENT_VIEW
} from 'constants/view-modes.js';

const sequencerReducer = (state ={
    viewMode: SEQUENCER_VIEW,
    showPianoRoll: false,
    alternateViewMode: ARRANGEMENT_VIEW,
    decentralized: true,
    waveformShowing: false,
    masterVolumes: {},
    showSelectorMode: false,
    resolution: new Resolution(16, false),
    displayResolution: new Resolution(16, false),
    numberOfPatterns: {},
    currentPattern: {},
    currentStep: {},
    currentGlobalStep: {},
    isPlaying: {},
    samplePack: undefined,
    sampleDragging: undefined,
    effectDragging: undefined,
    patternDragging: undefined,
    tracksRecording: {},
    tracksPreparingToRecord: {},
    trackSteps: {},
    quantized: true,
    isRecording: false,
    isRecordingExpanded: false,
    sequenceName: undefined,
    trackFocused: undefined,
    showSettings: false,
    loadingSequence: {},
    isCompactMode: false,
    showEnvelopes: false,
    showLFOs: false,
    selectedLFO: 1,
    selectedEnvelope: 1,
    automationMode: PLAY,
    showSequenceModal: false,
    showModsModal: false,
    sequenceRolling: false,
    trackRolling: false,
    showInstruments: false,
    showSequences: false,
    showPresets: false,
    zIndexHack: false,
    resampleMaster: false,
    audioInputSource: undefined,
    latency: 0,
    patternLocks: {},
    clockType: NONE,
    showConvolverModal: false,
    convolverSample: undefined,
    showLogin: false,
    signingUp: false,
    userToken: undefined,
    showPasswordModal: false,
    passwordModalCallback: undefined,
    contextualHelp: undefined,
    showGroups: false,
    currentSubSequence: {},
    subSequences: {},
    sidebarViewMode: SOUNDS,
    sequenceLoadingProgress: {},
    isTranscribing: false,
    scenes: [],
}, action) => {
    if (window.logRedux) {
        console.log("REDUX CALL ACTION=", action.type, action.payload);
    }
    let newState = {};
    let patternLocks = {};
    switch (action.type) {
    case NEW_SEQUENCE:
        return {... state, isPlaying: {}};
    case SET_RESOLUTION:
        return { ...state, resolution: action.payload};
    case SET_DISPLAY_RESOLUTION:
        return { ...state, displayResolution: action.payload};
    case SET_SEQUENCER_ENGINE:
        return { ...state, sequencerEngine: action.payload};
    case SET_VIEW_MODE:
        if (action.payload === SEQUENCER_VIEW) {
            newState = {
                ...state,
                viewMode: action.payload,
                showSelectorMode: false,
                sidebarViewMode: SOUNDS,
            };
        } else {
            newState = { ...state, viewMode: action.payload};
            if (action.payload === MIX_VIEW ||
                action.payload === ARRANGEMENT_VIEW) {
                newState.alternateViewMode = action.payload;
            }
        }
        return newState;
    case SET_DETAILS_VIEW:
        return { ...state, viewMode: action.payload};
    case SET_IS_TRANSCRIBING:
        return { ...state, isTranscribing: action.payload};
    case SET_SHOW_LOGIN:
        return { ...state, showLogin: action.payload};
    case SET_USER_TOKEN:
        if (action.payload.userName === undefined) {
            return { ...state, userToken: undefined};
        }
        return { ...state, userToken: action.payload};
    case SET_SIGNING_UP:
        return { ...state, signingUp: action.payload};
    case SET_SEQUENCE_LOADING_PROGRESS:
        let sequenceLoadingProgress = {... state.sequenceLoadingProgress};
        sequenceLoadingProgress[action.payload.sequenceId] = action.payload.progress;
        return { ...state, sequenceLoadingProgress};
    case SET_DECENTRALIZED:
        return { ...state, decentralized: action.payload};
    case SET_SELECTOR_MODE:
        return { ...state, showSelectorMode: action.payload};
    case SET_CURRENT_PATTERN:
        newState = {...state};
        newState.currentPattern[action.payload.sequenceId] = action.payload.currentPattern;
        return newState;
    case SET_NUMBER_PATTERNS:
        let numberOfPatterns = state.numberOfPatterns;
        numberOfPatterns[action.payload.id] = action.payload.numberOfPatterns;
        return { ...state, numberOfPatterns: numberOfPatterns};
    case SET_CURRENT_AND_GLOBAL_STEPS:
        newState = {...state};
        newState.currentStep[action.payload.sequenceId] = action.payload.currentStep;
        newState.currentGlobalStep[action.payload.sequenceId] = action.payload.currentGlobalStep;
        return newState;
    case SET_CURRENT_STEP:
        newState = {...state};
        newState.currentStep[action.payload.sequenceId] = action.payload.currentStep;
        return newState;
    case SET_CURRENT_GLOBAL_STEP:
        newState = {...state};
        newState.currentGlobalStep[action.payload.sequenceId] = action.payload.currentGlobalStep;
        return newState;
    case SET_SAMPLE_PACK:
        return { ...state, samplePack: action.payload};
    case DRAG_SAMPLE:
        return { ...state, sampleDragging: action.payload};
    case DRAG_EFFECT:
        return { ... state, effectDragging: action.payload};
    case DRAG_PATTERN:
        return { ... state, patternDragging: action.payload};
   case TRACK_RECORDING:
        newState = {... state};
        newState.tracksRecording[action.payload.id] = action.payload.recording;
        newState.tracksPreparingToRecord[action.payload.trackNumber] = false;
        return newState;
    case TRACK_PREPARING_TO_RECORD:
        newState = {... state};
        newState.tracksRecording[action.payload.trackNumber] = false;
        newState.tracksPreparingToRecord[action.payload.trackNumber] = action.payload.preparing;
        return newState;
    case SET_QUANTIZED:
        return {...state, quantized: action.payload };
    case SET_IS_RECORDING:
        return {...state, isRecording: action.payload};
    case SET_IS_RECORDING_EXPANDED:
        return {...state, isRecordingExpanded: action.payload};
    case SET_IS_PLAYING:
        let isPlaying = {... state.isPlaying};
        isPlaying[action.payload.sequenceId] = action.payload.isPlaying;
        newState = {...state, isPlaying: isPlaying};
        return newState;
    case SET_MASTER_VOLUME:
        newState = {...state};
        newState.masterVolumes[action.payload.sequenceId] = action.payload.volume;
        return newState;
    case SET_SEQUENCE_NAME:
        return {...state, sequenceName: action.payload};
    case SET_LATENCY:
        return {...state, latency: action.payload};
    case SET_TRACK_FOCUSED:
        return {...state, trackFocused: action.payload};
    case SET_COMPACT_MODE:
        return {...state, isCompactMode: action.payload};
    case SET_SHOW_LFOS:
        return {...state, showLFOs: action.payload, showEnvelopes: false};
    case SET_SELECTED_LFO:
        return {...state, selectedLFO: action.payload};
    case SET_SELECTED_ENVELOPE:
        return {...state, selectedEnvelope: action.payload};
    case SET_SHOW_ENVELOPES:
        return {...state, showEnvelopes: action.payload, showLFOs: false};
    case SET_CLOCK_TYPE:
        return {...state, clockType: action.payload};
    case SET_SHOW_SEQUENCE_MODAL:
        return {...state, showSequenceModal: action.payload};
    case SET_CONTEXTUAL_HELP:
        return {...state, contextualHelp: action.payload.element === undefined ? undefined : action.payload};
    case SET_SHOW_MODS_MODAL:
        return {...state, showModsModal: action.payload};
    case SET_LOADING_SEQUENCE:
        newState = {... state};
        let loading = action.payload.loading;
        let loadingSequence = {... newState.loadingSequence};
        loadingSequence[action.payload.id] = loading;
        newState.loadingSequence = loadingSequence;
        return newState;
    case SET_PROJECT_AUTOMATION_MODE:
        return {
            ... state,
            automationMode: action.payload
        };
    case SET_SEQUENCE_ROLLING:
        return {
            ... state,
            sequenceRolling: action.payload
        };
    case SET_TRACK_ROLLING:
        return {
            ... state,
            trackRolling: action.payload
        };
     case SET_SHOW_SEQUENCES:
        return {
            ...state,
            showSequences: action.payload
        };
     case SET_SHOW_INSTRUMENTS:
        return {
            ...state,
            showInstruments: action.payload
        };
     case SET_SHOW_PRESETS:
        return {
            ...state,
            showPresets: action.payload
        };
     case SET_Z_INDEX_HACK:
        return {
            ...state,
            zIndexHack: action.payload
        };
     case SET_RESAMPLE_MASTER:
        return {
            ...state,
            resampleMaster: action.payload
        };
     case SET_AUDIO_INPUT_SOURCE:
        return {
            ...state,
            audioInputSource: action.payload
        };
    case SET_SEQUENCE_PATTERN_LOCKED:
        patternLocks = {... state.patternLocks};
        if (!action.payload.subSequence in patternLocks) {
            patternLocks[action.payload.subSequence] = {};
        }
        patternLocks[action.payload.subSequence][action.payload.patternNumber] = action.payload.locked;
        return {
            ... state,
            patternLocks: patternLocks
        };
    case SET_SEQUENCE_PATTERN_LOCKS:
        patternLocks = {... state.patternLocks};
        if (!action.payload.subSequence in action.payload.patternLocks) {
            patternLocks[action.payload.subSequence] = {};
        }
        patternLocks[action.payload.subSequence] =
            action.payload.patternLocks;
        return {
            ... state,
            patternLocks: patternLocks,
        };
    case SET_SHOW_PASSWORD_MODAL:
        return {
            ... state,
            showPasswordModal: action.payload
        };
    case SET_PASSWORD_MODAL_CALLBACK:
        return {
            ... state,
            passwordModalCallback: action.payload
        };
    case SET_SHOW_CONVOLVER_MODAL:
        return {
            ... state,
            showConvolverModal: action.payload.show,
            convolverSample: action.payload.convolverSample,
        };
    case SET_SHOW_GROUPS:
        return {
            ... state,
            showGroups: action.payload
        };
    case SET_SHOW_PIANO_ROLL:
        return {
            ... state,
            showPianoRoll: action.payload
        };
    case SET_SUB_SEQUENCES:
        let subSequences = state.subSequences;
        subSequences[action.payload.sequenceId] = action.payload.ids;
        return {
            ... state,
            subSequences: subSequences
        };
    case SET_CURRENT_SUB_SEQUENCE:
        let currentSubSequence = state.currentSubSequence;
        currentSubSequence[action.payload.sequenceId] = action.payload.subSequenceId;
        return {
            ... state,
            currentSubSequence: currentSubSequence
        };
    case SET_SIDEBAR_VIEW_MODE:
        return {
            ... state,
            sidebarViewMode: action.payload
        };
    case SET_UPLOADING_FILE:
        return {
            ... state,
            uploadingFile: action.payload
        };
    case SET_LOADING_TEXT:
        return {
            ... state,
            loadingText: action.payload
        };
    case SET_SCENES:
        return {
            ... state,
            scenes: action.payload
        };
    case SET_CURRENT_SCENE:
        return {
            ... state,
            currentScene: action.payload
        };
    case SET_SHOW_SETTINGS:
        return {
            ... state,
            showSettings: action.payload
        };
    case SET_WALLPAPER:
        return {
            ... state,
            wallpaper: action.payload
        };
    case SET_ANIMATE_WALLPAPER:
        return {
            ... state,
            animateWallpaper: action.payload
        };
    case SET_WAVEFORM_SHOWING:
        return {
            ... state,
            waveformShowing: action.payload
        };
    default:
        return state;
    }
};

export default sequencerReducer;
